import { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [
    { title: "Refund Policy | ManUp" },
    {
      name: "description",
      content: "Refund policy for purchases made on ManUp.",
    },
  ];
};

export default function RefundPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>

      <p className="mb-4">
        All purchases made on <strong>ManUp</strong>, including Hearts and Pro
        subscriptions, are final and non-refundable. By completing a purchase,
        you acknowledge and agree that:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>
          No refunds will be issued for any reason, including unused time or
          unredeemed in-app items.
        </li>
        <li>
          All payments are processed securely via Stripe. We do not store any
          credit card information.
        </li>
        <li>
          It is your responsibility to ensure your device and account meet the
          requirements before making a purchase.
        </li>
      </ul>

      <p className="mb-4">
        If you believe you’ve experienced a billing error or unauthorized
        charge, contact us at{" "}
        <a
          href="mailto:getmochiday@gmail.com"
          className="text-blue-600 underline"
        >
          getmochiday@gmail.com
        </a>
        .
      </p>

      <p className="text-sm text-gray-600">
        This policy may be updated at any time without prior notice.
      </p>
    </div>
  );
}
